import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right-arrow",
  "use": "icon-right-arrow-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right-arrow\"><path d=\"M9.514 8.013L3.566 1.816c-.19-.19-.19-.38 0-.57L4.635.142c.19-.19.38-.19.57 0l7.265 7.586a.385.385 0 0 1 .106.285.385.385 0 0 1-.106.285l-7.266 7.586c-.166.166-.356.154-.57-.036L3.567 14.78c-.19-.19-.19-.38 0-.57l5.948-6.197z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol